import { RecommendationStoreState } from './types';
import { defaultState } from './utils';

export class RecommendationStoreAdapter {
    getAll(): RecommendationStoreState {
        const recommmendationState = localStorage.getItem('recommendations');

        if (!recommmendationState) {
            return defaultState;
        }

        try {
            return JSON.parse(recommmendationState);
        } catch (_) {
            return defaultState;
        }
    }

    save(state: RecommendationStoreState) {
        localStorage.setItem('recommendations', JSON.stringify(state));
    }
}
